import { ConfigTabNav, type ConfigTabItem } from '@/components/layout/ConfigTabNav';

const tabs: ConfigTabItem[] = [
  {
    value: 'members',
    labelKey: 'department.tabs.members',
    to: '/$slug/department/members'
  },
  {
    value: 'teams',
    labelKey: 'department.tabs.teams',
    to: '/$slug/department/teams'
  }
];

export function DepartmentTabsNav() {
  return <ConfigTabNav tabs={tabs} />;
}
